import styled from 'styled-components';
import { PropsHeader } from './index.types';

export const CardStyled = styled.div`
  background: ${props => props.theme.colors.surface};
  border-radius: ${props => props.theme.radii.md};
  box-shadow: ${props => props.theme.shadows.md};
`;

export const DivHeaderTitle = styled.div`
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  strong,
  b,
  div {
    font-family: ${props => props.theme.typography.fontFamily};
    font-style: normal;
    font-weight: ${props => props.theme.typography.weights.bold};
    font-size: ${props => props.theme.typography.sizes.sm};
    line-height: ${props => props.theme.typography.lineHeights.sm};
    color: ${props => props.theme.colors.white};
    text-transform: uppercase;
  }
`;

export const HeaderStyled = styled.div<PropsHeader>`
  background: linear-gradient(
    180deg,
    ${props => props.theme.colors.primary} 8.01%,
    ${props => props.theme.colors.primaryHover} 126.28%
  );
  border-radius: ${props => props.theme.radii.md} ${props =>
      props.theme.radii.md}
    0px 0px;
  padding: ${props => props.theme.spacing.md}
    ${props => props.theme.spacing.lg};
  display: flex;
  align-items: center;
  height: 61px;

  ${props => {
    if (props.btnEdit == true) {
      return `
                justify-content: space-between;
            `;
    } else {
      return `
                justify-content: center;
            `;
    }
  }}

  > h3 {
    font-family: ${props => props.theme.typography.fontFamily};
    font-style: normal;
    font-weight: ${props => props.theme.typography.weights.bold};
    font-size: ${props => props.theme.typography.sizes.sm};
    line-height: ${props => props.theme.typography.lineHeights.sm};
    color: ${props => props.theme.colors.white};
  }
`;

export const BodyStyled = styled.div`
  padding: ${props => props.theme.spacing.md}
    ${props => props.theme.spacing.lg};
  display: flex;
  flex-direction: column;
`;

export const BtnEdit = styled.button`
  background: none;
  border: 2px solid ${props => props.theme.colors.white};
  border-radius: ${props => props.theme.radii.md};
  padding: ${props => props.theme.spacing.xs}
    ${props => props.theme.spacing.lg};
  display: flex;
  justify-content: center;
  align-items: center;

  > span {
    color: ${props => props.theme.colors.white};
    padding: 0 !important;
    margin: 0 !important;
    font-weight: ${props => props.theme.typography.weights.semibold} !important;
    font-size: ${props => props.theme.typography.sizes.sm};
    line-height: ${props => props.theme.typography.lineHeights.sm};
    letter-spacing: 0.4px;
  }
`;

export const BtnCancel = styled.button`
  height: 46px;
  width: 203px;
  border-radius: ${props => props.theme.radii.md};
  background: ${props => props.theme.colors.danger};
  color: ${props => props.theme.colors.white};
  border: none;
`;

export const BtnSaveEdit = styled.button`
  height: 46px;
  width: 203px;
  border-radius: ${props => props.theme.radii.md};
  border: none;

  background: ${props => props.theme.colors.secondary};
  color: ${props => props.theme.colors.white};
`;

export const BtnEditSingle = styled.button`
  background: none;
  border: 2px solid ${props => props.theme.colors.white};
  border-radius: ${props => props.theme.radii.md};
  padding: ${props => props.theme.spacing.xs};
  display: flex;
  justify-content: center;
  align-items: center;

  > img {
    width: 20px;
    height: 20px;
    margin-left: 7px;
  }
`;
